import http from '../http';

/**
 * @namespace 角色权限模块
 */

export const getCompanyList = () => {
  return http.get(`companies`);
};

export const getWasteCompaniesWhoseProjectsAreManagedByTransportCompany = () => {
  return http.get(`companies/transport/waste`);
};

export const getCompanyById = (id: number) => {
  return http.get(`companies/${id}`, { returnFullResponse: true });
};

export const getCompaniesByDischargeId = (dischargeId: number, type: string) => {
  return http.get(`companies/discharge/${dischargeId}`, {
    params: { type },
    returnFullResponse: true
  });
};

export const createCompany = (company: any) => {
  return http.post(`companies`, company, { returnFullResponse: true });
};

export const getTransCompanies = (query: string) => {
  return http.get(`companies/transport?query=${query}`, { returnFullResponse: true });
};

export const deleteCompany = (id: number) => {
  return http.delete(`companies/${id}`, { returnFullResponse: true });
};

export const checkKeyRegisteredForCompany = async (subNumOrEdiKey: string, companyId: number) => {
  const res = await http.get(`companies/${companyId}/check-key-registered`, {
    params: {
      subNumOrEdiKey: subNumOrEdiKey
    }
  }) as any;
  return res.result as boolean;
}
